/* Chopzy — interacciones propias (prefijo mt-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contar]:not([data-mt-ok])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-mt-ok', '');
      var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toFixed(dec); return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('.mt-comp').forEach(function (c) {
      var r = c.querySelector('.mt-comp__rango');
      if (!r || r.dataset.mtOk) return;
      r.dataset.mtOk = '1';
      var set = function () { c.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var tick = false;
    function upd() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function dinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var conComa = v.replace('.', ',');
    var f = formato || '€{{amount}}';
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtOk) return;
      root.dataset.mtOk = '1';
      var datosEl = root.querySelector('[data-mt-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var formato = root.getAttribute('data-mt-formato');
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var principal = root.querySelector('.mt-pp__principal img');
      var minis = root.querySelectorAll('.mt-pp__mini');
      var boton = root.querySelector('[data-mt-anadir]');
      var textoBoton = boton ? boton.querySelector('span') : null;
      var txtComprar = boton ? boton.getAttribute('data-txt-comprar') : '';
      var txtAgotado = boton ? boton.getAttribute('data-txt-agotado') : '';
      var sticky = document.querySelector('.mt-sticky-compra');

      function verImagen(src, srcset, mini) {
        if (!principal || !src) return;
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.style.opacity = 1;
        }, 150);
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { verImagen(m.dataset.src, m.dataset.srcset, m); });
      });

      function opcionesElegidas() {
        var sel = [];
        root.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('legend span');
          if (lbl && c) lbl.textContent = c.value;
        });
        return sel;
      }
      function actualizar() {
        var sel = opcionesElegidas();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        root.querySelectorAll('[data-mt-precio]').forEach(function (el) { el.textContent = dinero(v.price, formato); });
        if (sticky) sticky.querySelectorAll('[data-mt-precio]').forEach(function (el) { el.textContent = dinero(v.price, formato); });
        var tach = root.querySelector('[data-mt-tachado]');
        var ahorro = root.querySelector('[data-mt-ahorro]');
        if (tach) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tach.textContent = dinero(v.compare_at_price, formato);
            tach.hidden = false;
            if (ahorro) { ahorro.hidden = false; ahorro.querySelector('b').textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { tach.hidden = true; if (ahorro) ahorro.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          if (textoBoton) textoBoton.textContent = v.available ? txtComprar : txtAgotado;
        }
        if (v.featured_media) {
          var mini = root.querySelector('.mt-pp__mini[data-media-id="' + v.featured_media.id + '"]');
          if (mini) verImagen(mini.dataset.src, mini.dataset.srcset, mini);
        }
        if (window.history && window.history.replaceState && !window.Shopify.designMode) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      root.querySelectorAll('.mt-pp__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = root.querySelector('.mt-pp__cantidad input');
      root.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-mt-cant'), 10);
          cant.value = Math.max(1, n);
        });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; // envío normal
          ev.preventDefault();
          var err = root.querySelector('.mt-pp__error');
          if (err) err.hidden = true;
          boton.disabled = true;
          var fd = new FormData(form);
          if (cant) fd.set('quantity', cant.value);
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            boton.disabled = false;
            if (res.status) {
              if (err) { err.textContent = res.description || res.message; err.hidden = false; }
              return;
            }
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          }).catch(function () { boton.disabled = false; form.submit(); });
        });
      }

      if (sticky && boton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('mt-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        io.observe(boton);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (boton.disabled) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (form.requestSubmit) form.requestSubmit(); else boton.click();
        });
      }
    });
  }

  function init() {
    initReveal();
    initContadores();
    initComparador();
    initParallax();
    initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
